import Vue from 'vue';
import UbicVueUI from '@ubic/vue-ui';
import router from './router';
import store from './store';
import App from './App.vue';
import './theme/app-styles.scss';

Vue.config.productionTip = false;

Vue.use(UbicVueUI);

(async () => {
  await store.dispatch('auth/check');

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
})();
